// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	// Menu Images Function
	let primaryNavigation = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	let menuGallery = document.querySelectorAll('.menu-block__images img');
	primaryNavigation.forEach((li, i)=>{
		li.addEventListener( "mouseenter", () => {
			let liIndex = i;
			menuGallery.forEach((img)=>{
				img.classList.remove('active');
			});
			menuGallery[liIndex].classList.add('active');
		});
	});

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

	// Menu Functionality

	let menuContent = document.getElementById("navigationBox");
	//Open/CLose
	if(menuContent){
		let header = document.getElementById("header");
		let menuBtn = document.querySelector("[data-toggle_nav]");	
		let menuLabel = menuBtn.querySelector('div.text');
		let body = document.querySelector('body');
		menuBtn.addEventListener('click', function (e) {
			console.log('condiciones');
			
			menuBtn.classList.toggle("open");
			menuContent.classList.toggle("open");
			header.classList.toggle("menuOpen");
			body.classList.toggle("no-overflow");
			if(document.querySelector('#navMenuBar')){
				document.querySelector('#navMenuBar').classList.toggle("open");
			}
			if (menuLabel.innerHTML == "Menu") {
				menuLabel.innerHTML = "Close";
			} else {
				menuLabel.innerHTML = "Menu";
			}
		});

	}

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	const textModules = document.querySelectorAll(".text-modules");

	textModules.forEach(mod => {
		mod.querySelectorAll("[style]").forEach(el => el.removeAttribute("style"));

		mod.querySelectorAll("table").forEach(table => {
			const rows = table.querySelectorAll("tr");
	  		if (rows.length === 0) return;

			const headerCells = rows[0].children;

			rows.forEach(row => {
				row.querySelectorAll("td").forEach((cell, i) => {
					cell.setAttribute("data-heading", headerCells[i].textContent);
				});
			});
		});
	});

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}